import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { REDIRECT_URLS } from "../../../globalConstants";
import { inject } from "../../../lib/itn-ui-kit/services/service-container";

const ProtectedRoute = ({ children }) => {
  const currentUserService = inject("current-user-service");

  const location = useLocation();
  const accessibleRoutes = currentUserService.accessibleRoutes;

  const isRouteAccessible = accessibleRoutes.some((route) => location.pathname.includes(route));

  if (!isRouteAccessible) {
    return <Navigate to={REDIRECT_URLS.DASHBOARD} replace />;
  }

  return children;
};

export default ProtectedRoute;
